var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgS2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5 72C56.3823 72 72.5 55.8823 72.5 36C72.5 16.1177 56.3823 0 36.5 0C16.6177 0 0.5 16.1177 0.5 36C0.5 55.8823 16.6177 72 36.5 72Z",
    fill: "#26362D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0879 41.026C41.0879 42.4067 42.2072 43.526 43.5879 43.526C44.9686 43.526 46.0879 42.4067 46.0879 41.026C46.0879 39.6453 44.9686 38.526 43.5879 38.526C42.2072 38.526 41.0879 39.6453 41.0879 41.026Z",
    stroke: "#2ECC71",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0879 36.026V26.026C24.5957 27.0616 32.0482 28.4039 41.0942 29.0307C45.9632 29.3681 48.3977 29.5368 49.7427 30.9875C51.0879 32.4382 51.0879 34.7755 51.0879 39.4503V42.8065C51.0879 47.6203 51.0879 50.0273 49.4484 51.5257C47.8087 53.0238 45.5744 52.8055 41.1056 52.369C40.0166 52.2625 38.8956 52.136 37.7546 51.9863",
    stroke: "#2ECC71",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4642 29.3593C46.0937 26.9872 46.6634 22.673 44.9662 20.5308C43.8906 19.1731 42.2917 19.3035 40.7242 19.4414C32.4844 20.1661 26.6636 21.6382 23.4096 22.6383C22.0104 23.0683 21.0879 24.4347 21.0879 25.96",
    stroke: "#2ECC71",
    strokeWidth: 3,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4212 46.026H27.7546M27.7546 46.026H21.0879M27.7546 46.026V52.6926M27.7546 46.026V39.3593",
    stroke: "#2ECC71",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS2);
export default __webpack_public_path__ + "static/media/s2.b02ca2b964dd51df8378092a710e37ce.svg";
export { ForwardRef as ReactComponent };